import { render } from "./ClienteListagem.vue?vue&type=template&id=402be59e&scoped=true&ts=true"
import script from "./ClienteListagem.vue?vue&type=script&lang=ts"
export * from "./ClienteListagem.vue?vue&type=script&lang=ts"

import "./ClienteListagem.vue?vue&type=style&index=0&id=402be59e&scoped=true&lang=css"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402be59e"]])

export default __exports__